module.exports = __webpack_public_path__ + "static/media/5k.d523c34e.jpg";